import { Flex, Grid, Space, Text, Skeleton } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { RaffleItem } from '../raffle-item';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useRaffleStore } from '../../RaffleStore';
import { RaffleTime } from '@web/common';
import { useWindowSize } from '../../../../../../hooks';
import { InteractiveText } from '../../../../../../component/InteractiveText';
import { Routes } from '../../../../../../route/Routes';
import { EmptyActiveRaffles } from '../../../news';

export const ActiveRaffles = observer(
  ({
    limit,
    showHeader = false,
    grow = false,
    showEmptyState = true,
  }: {
    limit?: number;
    showHeader?: boolean;
    grow?: boolean;
    showEmptyState?: boolean;
  }) => {
    const isSmallScreen = useWindowSize(600);
    const { t } = useTranslation('raffle');
    const store = useRaffleStore();
    const hasMoreItems = store.activeRaffles?.length > 0;

    useEffect(() => {
      store.loadActiveRaffles();
    }, [store]);

    const hasRaffles = store.activeRaffles?.length > 0;
    const rafflesToShow = limit
      ? store.activeRaffles?.slice(0, limit)
      : store.activeRaffles;

    return (
      <>
        {showHeader && (
          <>
            <Space h="20px" />
            <Flex justify="space-between">
              <Text size="21px" lh="24px" fw="600">
                {t('ActiveRaffles')}
              </Text>
              {!isSmallScreen && hasMoreItems && (
                <InteractiveText
                  text={t('ShowAll')}
                  navigateTo={`${Routes.Study}/${Routes.Raffles}/${Routes.ActiveRaffles}`}
                />
              )}
            </Flex>
          </>
        )}

        {store.isLoadingActive ? (
          <Skeleton height={100} radius="8px" />
        ) : hasRaffles ? (
          <Grid grow={grow}>
            {rafflesToShow?.map((raffle) => (
              <Grid.Col span={{ base: 12, md: 6 }} key={raffle.sys.id}>
                <RaffleItem
                  key={raffle.sys.id}
                  data={raffle}
                  time={RaffleTime.Active}
                />
              </Grid.Col>
            ))}
          </Grid>
        ) : (
          showEmptyState && <EmptyActiveRaffles />
        )}

        {showHeader && isSmallScreen && hasMoreItems && (
          <InteractiveText
            text={t('ShowAll')}
            navigateTo={`${Routes.Study}/${Routes.Raffles}/${Routes.ActiveRaffles}`}
          />
        )}
      </>
    );
  },
);
